import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/assistant.png'


const _hoisted_1 = { class: "fixed bottom-4 right-0 z-999" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8 h-auto"
}, null, -1)

import { ref } from "vue";
import Btn from "../ui/Btn.vue";
import ChatbotUi from "./ChatbotUi.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatbotFab',
  props: {
    courseId: null
  },
  setup(__props: any) {



const chatbotOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!chatbotOpen.value)
      ? (_openBlock(), _createBlock(Btn, {
          key: 0,
          class: "text-onPrimary bg-primary bg-opacity-20 hover:bg-primary hover:bg-opacity-30 fixed bottom-10 right-10 shadow-elevation p-2",
          variant: 'icon',
          outline: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (chatbotOpen.value = true))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(ChatbotUi, {
          key: 1,
          class: "mb-4 mr-4",
          style: {"width":"65vw"},
          courseId: __props.courseId,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (chatbotOpen.value = false))
        }, null, 8, ["courseId"]))
  ]))
}
}

})